import { render, staticRenderFns } from "./ModalStatus.vue?vue&type=template&id=63b9478e&scoped=true&"
import script from "./ModalStatus.vue?vue&type=script&lang=ts&"
export * from "./ModalStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStatus.vue?vue&type=style&index=0&id=63b9478e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9478e",
  null
  
)

export default component.exports